import { NavBar } from '@/components/design-system/NavBar';
import { Skeleton } from '@/components/design-system/Skeleton';

export const QuestionnaireLoadingSkeleton = () => {
  return (
    <div className="flex flex-col h-screen">
      <NavBar
        returnButtonTitle="Save & Exit"
        className="px-4 md:px-8 border-b border-gray-200"
      />
      <div className="flex-1 overflow-hidden">
        <div className="h-full overflow-y-auto px-4 pb-24">
          {/* Title and Progress Section */}
          <div className="text-center mt-8 mb-3">
            <Skeleton className="h-8 w-64 mx-auto mb-2" /> {/* Title */}
            <Skeleton className="h-4 w-24 mx-auto" /> {/* Page counter */}
          </div>

          <div className="max-w-[73.375rem] mx-auto md:px-8 lg:px-28">
            {/* Progress Bar */}
            <div className="w-full h-1 bg-[#E5E7EB] rounded-full overflow-hidden mb-12">
              <Skeleton className="h-full w-[8%]" />
            </div>
          </div>

          <div className="max-w-[600px] mx-auto">
            {/* Question Title */}
            <div className="mb-6">
              <Skeleton className="h-7 w-3/4 mb-2" />
              <Skeleton className="h-4 w-1/2" />
            </div>

            {/* Radio Options */}
            {Array.from({ length: 4 }).map((_, index) => (
              <div key={index} className="mb-4">
                <div className="flex items-center space-x-3 bg-white p-4 rounded-lg border border-gray-100">
                  <Skeleton className="h-5 w-5 rounded-full" />{' '}
                  {/* Radio circle */}
                  <Skeleton className="h-6 flex-1" /> {/* Option text */}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Navigation */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 max-md:bottom-16">
        <div className="ml-[15.25rem] max-md:ml-0">
          <div className="w-full mx-auto p-4 md:px-8 lg:px-28 lg:py-6 max-w-[73.375rem]">
            <div className="flex justify-between items-center">
              <Skeleton className="h-10 w-28" /> {/* Previous button */}
              <Skeleton className="h-10 w-28" /> {/* Next button */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
